import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-71048546"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ui-ns__elm-selected" }
const _hoisted_2 = { class: "ui-ns__elm-selected-label" }
const _hoisted_3 = {
  key: 0,
  class: "ui-ns__list"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ui-ns__list-line" }, null, -1))
const _hoisted_5 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconChevronDown = _resolveComponent("IconChevronDown")!

  return (_openBlock(), _createElementBlock("div", {
    class: "ui-ns",
    onFocusout: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onFocusOut && _ctx.onFocusOut(...args))),
    tabindex: "0"
  }, [
    _createElementVNode("div", {
      class: "ui-ns__elm",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.formatBalance(_ctx.select * _ctx.COEFFICIENT)), 1),
        _createVNode(_component_IconChevronDown)
      ])
    ]),
    (_ctx.isShow)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _hoisted_4,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.total, (index) => {
            return (_openBlock(), _createElementBlock("div", {
              onClick: ($event: any) => (_ctx.onClickSelect(index)),
              class: _normalizeClass(
					_ctx.select === index
						? 'ui-ns__list-item-select'
						: 'ui-ns__list-item'
				),
              key: index
            }, _toDisplayString(_ctx.formatBalance(index * _ctx.COEFFICIENT)), 11, _hoisted_5))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 32))
}